import { useEffect, useRef, useState } from 'react';
import './Contact.css';


const links = [
    { label: 'Email', value: 'emanuel.soares.brandao@gmail.com', href: 'mailto:emanuel.soares.brandao@gmail.com' },
    { label: 'GitHub', value: 'github.com/EmanuelSoares112', href: 'https://github.com/EmanuelSoares112' },
    { label: 'LinkedIn', value: 'linkedin.com/in/emanuel-soares-78b327385', href: 'https://www.linkedin.com/in/emanuel-soares-78b327385/' },
];

export default function Contact({ id }) {
    const sectionRef = useRef(null);
    const [visible, setVisible] = useState(false);
    const [lineVisible, setLineVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setTimeout(() => setLineVisible(true), 100);
                    setTimeout(() => setVisible(true), 300);
                }
            },
            { threshold: 0.15 }
        );
        if (sectionRef.current) observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, []);

    return (
        <div className="contact-container" id={id} ref={sectionRef}>

            <div className={`section-label ${visible ? 'section-label--visible' : ''}`}>
                <span>05</span>
                <span>CONTACTO</span>
            </div>

            <div className={`section-line ${lineVisible ? 'section-line--visible' : ''}`} />

            <div className="contact-inner">

                <div className="contact-left">
                    <h2 className={`section-title ${visible ? 'section-title--visible' : ''}`}>
                        <span>Vamos</span>
                        <span className="text-outline">trabalhar</span>
                        <span>juntos.</span>
                    </h2>
                    <p className={`contact-text ${visible ? 'contact-text--visible' : ''}`} style={{ transitionDelay: '0.4s' }}>
                        Estou atualmente à procura de emprego na área de desenvolvimento e também disponível para projetos freelance.
                        <br />
                        Se procuras alguém dedicado, focado em qualidade e evolução contínua, vamos conversar!
                    </p>
                </div>

                <div className="contact-right">
                    {links.map((link, i) => (
                        <a
                            key={link.label}
                            href={link.href}
                            className={`contact-link ${visible ? 'contact-link--visible' : ''}`}
                            style={{ transitionDelay: `${0.3 + i * 0.12}s` }}
                            target={link.href.startsWith('http') ? '_blank' : undefined}
                            rel="noreferrer"
                        >
                            <div className="contact-link-inner">
                                <span className="contact-link-label">{link.label}</span>
                                <span className="contact-link-value">{link.value}</span>
                            </div>
                            <svg className="contact-link-arrow" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                <path d="M7 17L17 7M17 7H7M17 7V17" />
                            </svg>
                        </a>
                    ))}
                </div>

            </div>

            <div className={`section-line section-line--bottom ${lineVisible ? 'section-line--visible' : ''}`} />
        </div>
    );
}